import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
// import { ToastsManager } from 'ng2-toastr';
import { environment } from 'src/environments/environment';
import { Urls } from '../utilities/urls.component';
import { ExcryptionService } from './excryption.service';
import { GeneralService } from './general.service';

@Injectable()
export class ErrorHandlerService {
  constructor(private GS: GeneralService, private router: Router, private excryptionService: ExcryptionService) {}

  checkAndShowpageError(errorCode: string, page: any) {
    if (errorCode == 'E204') {
      this.GS.sendNote({
        text: 'Due to inactivity, you will be logged out of the portal soon',
        duration: 10000,
        type: 'danger',
      });
      setTimeout(() => {
        this.logoutWithRedirect();
      }, 5000);
    }
  }

  async logoutWithRedirect() {
      const uri = environment.uri;
      const keyHex = environment.ENCRYPTION_KEY_URI; // Use your actual 256-bit key in hex
      const client_name = environment.productID;
      const encryptedUri = await this.excryptionService.encrypt(uri, keyHex);
      const finalUrl = Urls.HOME_ENDPOINT + Urls.HOME.login + "?redirect_uri=" + encodeURIComponent(encryptedUri)+"&client_name="+client_name;
      window.location.href = finalUrl
    }
}
